/*
 * File: GetSection.ts
 * Author: Austin Robinson
 * Date Created: 8/3/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { privateApi } from 'api';

export interface GetSectionParams {
  id: string;
}

export type CourseSection = {
  tenant_id: string;
  id: string;
  course_id: string;
  title: string;
  description: string | null;
  open_enrollment: string | null;
  close_enrollment: string | null;
  capacity: number;
  tenant_location_id: string | null;
  des_id: null;
  total_enrollment_count: '0';
  course: {
    tenant_id: string;
    id: string;
    course_type: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
    schedule_type: 'self_scheduled' | 'fixed' | 'manual' | 'no_schedule';
    title: string;
    description: string | null;
    created_at: string | null;
    created_by: string | null;
    updated_at: string | null;
    updated_by: string | null;
  };
  tenant_location: {
    tenant_id: string;
    id: string;
    name: string;
    street_address: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    disabled: boolean;
  } | null;
} | null;

async function getSection(params: GetSectionParams): Promise<CourseSection> {
  // make api call
  const result = await privateApi.get<CourseSection>(
    `${import.meta.env.VITE_API_BASE_URL}/courses/sections/${params.id}`,
  );

  // return the data object
  return result.data;
}

const useGetSection = createQuery<CourseSection, GetSectionParams, Error>({
  queryKey: ['section'],
  fetcher: (variables) => getSection(variables),
});

export { getSection, useGetSection };
